import React from 'react';
import { AccountingPage } from './AccountingPage';

export function ServicePage(props) {
  let mainContent;

  const {
    page
  } = props;

  switch (page) {
    case 'accounting':
      mainContent = <AccountingPage />;
      break;
  
    default:
      break;
  }
  return (
    <div className="service-page">
      ServicePage
      { mainContent }
    </div>
  )
}